import React from 'react';

class AreaTitle extends React.Component {
  render() {
    return <div className="area-title">{this.props.text}</div>;
  }
}

export default AreaTitle;
